export default __webpack_public_path__ + "maps-examples-building-extrusions-thumbnail-960-ac3e45deb76033dd032ae376a51b162b.webp";